import { Router, Route } from "@solidjs/router";
import { lazy } from "solid-js";
import AuthGuard from "./layouts/AuthGuard";
import MapLayout from "./layouts/MapLayout";
import PageLayout from "./layouts/PageLayout";

const Home = lazy(() => import("./routes/index"));
const Settings = lazy(() => import("./routes/settings"));
const Login = lazy(() => import("./routes/auth/login"));
const Logout = lazy(() => import("./routes/auth/logout"));

export default function App() {
  return (
    <Router>
      <Route component={AuthGuard}>
        <Route component={MapLayout}>
          <Route path="/" component={Home} />
        </Route>
        <Route component={PageLayout}>
          <Route path="/settings" component={Settings} />
        </Route>
      </Route>
      <Route component={PageLayout}>
        <Route path="/auth/login" component={Login} />
        <Route path="/auth/logout" component={Logout} />
      </Route>
    </Router>
  );
}
